export default __webpack_public_path__ + "static/media/user.a912c6fe.svg";